import { get } from "lodash";
import { Helpers } from "../../utils/helper";
import { Owner } from "./Owner.model";

export class HoldingOwner extends Owner{
  id              : string; //this will be used for animation accordion when remove
  type            : "existing" | "new" | "additional";
  is_proposed     : boolean | undefined;
  original_uinfin : string | undefined;
  existing_type?: "owner" | "occupier" | "additional" | "";
  constructor(initial?:any){
    super(initial);
    this.id          = get(initial, 'id', Helpers.generateAlphaNumericID());
    this.type        = get(initial, 'type', 'new');
    this.is_proposed = get(initial, 'is_proposed', undefined);
    this.original_uinfin = get(initial, 'original_uinfin', undefined);
    this.existing_type = get(initial, 'existing_type', "");
  }
  
}
